import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Dashboard from "./components/dashboard";
import { Login } from "./components/login";
import Header from "./components/header";
import { Sidebar } from "./components/sidebar";

const App: React.FC<any> = ({selectedMenu}) => {

  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(localStorage.getItem("isLoggedIn") == "true"); 
  const [darkMode, setDarkMode] = useState<boolean>(false);
  const [roleId, setRoleId] = useState<any | number | null>(null);
  const [municipalityName, setMunicipalityName] = useState<string>("");
  const [municipalityId, setMunicipalityId] = useState<string>("");
  const [municipalityLogo, setMunicipalityLogo] = useState<any>(null);
  const [municipalityBanner, setMunicipalityBanner] = useState<any>(null);

  useEffect(() => {
  
    const storedLoginState = localStorage.getItem("isLoggedIn");
    const storedRoleId = localStorage.getItem("roleId");
    const storedMunicipalityName = localStorage.getItem("municipalityName");
    const storedMunicipalityId = localStorage.getItem("municipalityId");
    const storedMunicipalityBanner = localStorage.getItem("municipalityBanner");
    const storedMunicipalityLogo = localStorage.getItem("municipalityLogo");

    if (storedLoginState === "true") {
      setIsLoggedIn(true);
      setRoleId(storedRoleId);
      setMunicipalityName(storedMunicipalityName || "");
      setMunicipalityId(storedMunicipalityId || "");
      setMunicipalityBanner(storedMunicipalityBanner || null);
      setMunicipalityLogo(storedMunicipalityLogo || null);
    }
  }, []);

  const handleLogin = (role_id: any, municipalityName: string, municipalityId: any, municipalityLogo: any, banner_image: any, token: any,role_name:any) => {
    setIsLoggedIn(true); 
    setRoleId(role_id);
    setMunicipalityName(municipalityName);
    setMunicipalityId(municipalityId);
    setMunicipalityLogo(municipalityLogo);
    setMunicipalityBanner(banner_image);

    localStorage.setItem("isLoggedIn", "true");
    localStorage.setItem("roleId", role_id);
    localStorage.setItem("municipalityName", municipalityName);
    localStorage.setItem("municipalityId", municipalityId);
    localStorage.setItem("municipalityBanner", banner_image); // Consistent key
    localStorage.setItem("municipalityLogo", municipalityLogo); // Consistent key
    localStorage.setItem("token",token);
    localStorage.setItem('role_name',role_name);

  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setRoleId(null);

    // Clear the stored login state and data
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("roleId");
    localStorage.removeItem("municipalityName");
    localStorage.removeItem("municipalityId");
    localStorage.removeItem("municipalityBanner");
    localStorage.removeItem("municipalityLogo");
    localStorage.removeItem("selectedMenu");
    localStorage.removeItem("municipalityLoginId");
    localStorage.removeItem("token");
    localStorage.removeItem('role_name');
    localStorage.removeItem('street_id');
    localStorage.removeItem('role_type');
    localStorage.removeItem('user_name');
    localStorage.removeItem('user_id');
    localStorage.removeItem('role_id');
    localStorage.removeItem('getMunicipalityIdFromSuperAdmin');
    sessionStorage.removeItem('activeLink');
    localStorage.removeItem('municipality_id_v2');
    localStorage.removeItem('municipality_name_v2');
    localStorage.removeItem('ward');
    localStorage.removeItem('selected_collector_municipality');

  };

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("dark");
    } else {
      document.body.classList.remove("dark");
    }
  }, [darkMode]);




  return (

    <Router>
      <div className="min-h-screen bg-gray-100 dark:bg-gray-900">
        {isLoggedIn && (
          <>
            <Header />
            <Sidebar onLogout={handleLogout} roleId={roleId} municipalityLogo={municipalityLogo} />
          </>
        )}

        <Routes>
          <Route
            path="/"
            element={isLoggedIn ? <Navigate to="/dashboard/overview" /> : <Login onLogin={handleLogin} />}
          />
          <Route
            path="/dashboard/*"
            element={isLoggedIn ? <Dashboard roleId={roleId} muniCipalityName={municipalityName} municipalityId={municipalityId} logo={municipalityLogo} municipalityBanner={municipalityBanner} isLogin={isLoggedIn} /> : <Navigate to="/" />}
          />
        </Routes>
      </div>
    </Router>

  );
};

export default App;




// import React, { useState, useEffect } from "react";
// import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
// import Dashboard from "./components/dashboard";
// import { Login } from "./components/login";
// import Header from "./components/header";
// import { Sidebar } from "./components/sidebar";

// const App: React.FC<any> = ({ selectedMenu }) => {
//   const [isLoggedIn, setIsLoggedIn] = useState<boolean>(sessionStorage.getItem("isLoggedIn") === "true");
//   const [darkMode, setDarkMode] = useState<boolean>(false);
//   const [roleId, setRoleId] = useState<any | number | null>(null);
//   const [municipalityName, setMunicipalityName] = useState<string>("");
//   const [municipalityId, setMunicipalityId] = useState<string>("");
//   const [municipalityLogo, setMunicipalityLogo] = useState<any>(null);
//   const [municipalityBanner, setMunicipalityBanner] = useState<any>(null);
//   const [getUrl, SetgetUrl] = useState<any>(null);

//   // Check if user is logged in from sessionStorage
//   useEffect(() => {
//     const storedLoginState = localStorage.getItem("isLoggedIn");
//     const storedRoleId = localStorage.getItem("roleId");
//     const storedMunicipalityName = localStorage.getItem("municipalityName");
//     const storedMunicipalityId = localStorage.getItem("municipalityId");
//     const storedMunicipalityBanner = localStorage.getItem("municipalityBanner");
//     const storedMunicipalityLogo = localStorage.getItem("municipalityLogo");

//     if (storedLoginState === "true") {
//       setIsLoggedIn(true);
//       setRoleId(storedRoleId);
//       setMunicipalityName(storedMunicipalityName || "");
//       setMunicipalityId(storedMunicipalityId || "");
//       setMunicipalityBanner(storedMunicipalityBanner || null);
//       setMunicipalityLogo(storedMunicipalityLogo || null);
//     }

//     // Listen to beforeunload event to handle tab close
//     const handleTabClose = () => {
//       sessionStorage.removeItem("isLoggedIn");
//     };

//     window.addEventListener("beforeunload", handleTabClose);

//     return () => {
//       window.removeEventListener("beforeunload", handleTabClose);
//     };
//   }, []);

//   // Handle login
//   const handleLogin = (role_id: any, municipalityName: string, municipalityId: any, municipalityLogo: any, banner_image: any) => {
//     setIsLoggedIn(true);
//     setRoleId(role_id);
//     setMunicipalityName(municipalityName);
//     setMunicipalityId(municipalityId);
//     setMunicipalityLogo(municipalityLogo);
//     setMunicipalityBanner(banner_image);

//     // Set login state in sessionStorage and persistent data in localStorage
//     sessionStorage.setItem("isLoggedIn", "true");
//     localStorage.setItem("roleId", role_id);
//     localStorage.setItem("municipalityName", municipalityName);
//     localStorage.setItem("municipalityId", municipalityId);
//     localStorage.setItem("municipalityBanner", banner_image);
//     localStorage.setItem("municipalityLogo", municipalityLogo);
//   };

//   // Handle logout
//   const handleLogout = () => {
//     setIsLoggedIn(false);
//     setRoleId(null);

//     // Clear sessionStorage and localStorage data
//     sessionStorage.removeItem("isLoggedIn");
//     localStorage.removeItem("roleId");
//     localStorage.removeItem("municipalityName");
//     localStorage.removeItem("municipalityId");
//     localStorage.removeItem("municipalityBanner");
//     localStorage.removeItem("municipalityLogo");

//     // Also set isLoggedIn in localStorage to false to sync across tabs
//     localStorage.setItem("isLoggedIn", "false");
//     SetgetUrl(null);
//   };

//   useEffect(() => {
//     if (darkMode) {
//       document.body.classList.add("dark");
//     } else {
//       document.body.classList.remove("dark");
//     }
//   }, [darkMode]);

//   return (
//     <Router>
//       <div className="min-h-screen bg-gray-100 dark:bg-gray-900">
//         {isLoggedIn && (
//           <>
//             <Header darkMode={darkMode} setDarkMode={setDarkMode} />
//             <Sidebar onLogout={handleLogout} roleId={roleId} municipalityLogo={municipalityLogo} />
//           </>
//         )}

//         <Routes>
//           <Route
//             path="/"
//             element={isLoggedIn ? <Navigate to="/dashboard/overview" /> : <Login onLogin={handleLogin} />}
//           />
//           <Route
//             path="/dashboard/*"
//             element={isLoggedIn ? (
//               <Dashboard
//                 roleId={roleId}
//                 muniCipalityName={municipalityName}
//                 municipalityId={municipalityId}
//                 logo={municipalityLogo}
//                 municipalityBanner={municipalityBanner}
//                 isLogin={isLoggedIn}
//               />
//             ) : <Navigate to="/" />}
//           />
//         </Routes>
//       </div>
//     </Router>
//   );
// };

// export default App;
